import { render, staticRenderFns } from "./OeGen.vue?vue&type=template&id=06068b81&scoped=true&"
import script from "./OeGen.vue?vue&type=script&lang=js&"
export * from "./OeGen.vue?vue&type=script&lang=js&"
import style0 from "./OeGen.vue?vue&type=style&index=0&id=06068b81&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06068b81",
  null
  
)

export default component.exports